package ai.flowstorm.studio.model

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.id.newId
import ai.flowstorm.common.model.AbstractEntity
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class GeneratedSample(
    override val _id: Id = newId(),
    val serviceName: String,
    val modelId: String,
    val timestamp: String,
    val turn_id: Id? = null,
    var input: JsonObject,
    var output: JsonObject? = null,
    val modified: List<String>? = null,
    val taskName: String = "",
    val elapsedTime: Long? = null,
    val segmentTimes: List<Long>? = null
): AbstractEntity() {
    override val label get() = "generatedSample"
    // FIXME get rid of this ugly code
    val timeAsString get () = timestamp
        .replace("-", "/")
        .replace("T", " ")
        .replace("(.*)\\.(.*)".toRegex(), "$1")
}